import type { PhoneNumberType } from '@getstep/sdk/dist/util/Random'

export const WHITELISTED_VERIFY_CODE = '123456'

export const loadTestApiFactory = () =>
    import('./factory').then(({ testApiFactory }) => testApiFactory)

export async function inviteAdult(adult: { phoneNumber: string }) {
    const testApiFactory = await loadTestApiFactory()
    return testApiFactory.inviteAdult(adult)
}

/**
 * Web validation rules are a bit harsher than on client.
 */
export const generatePhone = async (
    type: PhoneNumberType.Normal | PhoneNumberType.ForceSignup,
): Promise<string> => {
    const testApiFactory = await loadTestApiFactory()
    return testApiFactory.generatePhone(type)
}

export const generateEmail = async () => {
    const testApiFactory = await loadTestApiFactory()
    return testApiFactory.getUnlinkedEmail()
}

export const generateDateInput = async () => {
    const testApiFactory = await loadTestApiFactory()
    return testApiFactory.generateDateInput()
}
